import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faCartShopping,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Navbar, Container } from "react-bootstrap";

import Logo from "../../Assets/Image/Logo.svg";
import styles from "./NavBar.module.css";
import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
function NavBar(props) {
  const [isActive, setIsActive] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const cart = useSelector((state) => state.cart);

  const clickHandler = () => {
    setIsActive(!isActive);
    props.drawer();
  };
  return (
    <>
      <nav className={`${styles.navSmall} d-sm-block d-lg-none`}>
        <div className="d-flex justify-content-between align-items-center">
          <span onClick={clickHandler}>
            {props.open === false ? (
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.75023 5.62488C3.58459 5.62254 3.42013 5.65314 3.26642 5.71491C3.11271 5.77667 2.97281 5.86838 2.85485 5.98468C2.73689 6.10099 2.64322 6.23958 2.57928 6.3924C2.51535 6.54522 2.48242 6.70922 2.48242 6.87488C2.48242 7.04054 2.51535 7.20454 2.57928 7.35736C2.64322 7.51018 2.73689 7.64878 2.85485 7.76508C2.97281 7.88139 3.11271 7.97309 3.26642 8.03485C3.42013 8.09662 3.58459 8.12722 3.75023 8.12488H26.2502C26.4159 8.12722 26.5803 8.09662 26.734 8.03485C26.8877 7.97309 27.0276 7.88139 27.1456 7.76508C27.2636 7.64878 27.3572 7.51018 27.4212 7.35736C27.4851 7.20454 27.518 7.04054 27.518 6.87488C27.518 6.70922 27.4851 6.54522 27.4212 6.3924C27.3572 6.23958 27.2636 6.10099 27.1456 5.98468C27.0276 5.86838 26.8877 5.77667 26.734 5.71491C26.5803 5.65314 26.4159 5.62254 26.2502 5.62488H3.75023ZM3.75023 13.7499C3.58459 13.7475 3.42013 13.7781 3.26642 13.8399C3.11271 13.9017 2.97281 13.9934 2.85485 14.1097C2.73689 14.226 2.64322 14.3646 2.57928 14.5174C2.51535 14.6702 2.48242 14.8342 2.48242 14.9999C2.48242 15.1655 2.51535 15.3295 2.57928 15.4824C2.64322 15.6352 2.73689 15.7738 2.85485 15.8901C2.97281 16.0064 3.11271 16.0981 3.26642 16.1599C3.42013 16.2216 3.58459 16.2522 3.75023 16.2499H26.2502C26.4159 16.2522 26.5803 16.2216 26.734 16.1599C26.8877 16.0981 27.0276 16.0064 27.1456 15.8901C27.2636 15.7738 27.3572 15.6352 27.4212 15.4824C27.4851 15.3295 27.518 15.1655 27.518 14.9999C27.518 14.8342 27.4851 14.6702 27.4212 14.5174C27.3572 14.3646 27.2636 14.226 27.1456 14.1097C27.0276 13.9934 26.8877 13.9017 26.734 13.8399C26.5803 13.7781 26.4159 13.7475 26.2502 13.7499H3.75023ZM3.75023 21.8749C3.58459 21.8725 3.42013 21.9031 3.26642 21.9649C3.11271 22.0267 2.97281 22.1184 2.85485 22.2347C2.73689 22.351 2.64322 22.4896 2.57928 22.6424C2.51535 22.7952 2.48242 22.9592 2.48242 23.1249C2.48242 23.2905 2.51535 23.4545 2.57928 23.6074C2.64322 23.7602 2.73689 23.8988 2.85485 24.0151C2.97281 24.1314 3.11271 24.2231 3.26642 24.2849C3.42013 24.3466 3.58459 24.3772 3.75023 24.3749H26.2502C26.4159 24.3772 26.5803 24.3466 26.734 24.2849C26.8877 24.2231 27.0276 24.1314 27.1456 24.0151C27.2636 23.8988 27.3572 23.7602 27.4212 23.6074C27.4851 23.4545 27.518 23.2905 27.518 23.1249C27.518 22.9592 27.4851 22.7952 27.4212 22.6424C27.3572 22.4896 27.2636 22.351 27.1456 22.2347C27.0276 22.1184 26.8877 22.0267 26.734 21.9649C26.5803 21.9031 26.4159 21.8725 26.2502 21.8749H3.75023Z"
                  fill="black"
                />
              </svg>
            ) : (
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.49395 3.78748L3.7877 5.49373L13.2939 15L3.73145 24.5812L5.41895 26.2687L15.0002 16.7062L24.5627 26.2687L26.2689 24.5625L16.7064 15L26.2127 5.49373L24.5064 3.78748L15.0002 13.2937L5.49395 3.78748Z"
                  fill="black"
                />
              </svg>
            )}
          </span>
          <NavLink className="ms-3" to="/">
            <img src={Logo} alt="Mr Cafe" />
          </NavLink>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <Link
            to="/cart"
            className={`d-flex align-items-center gap-2 ${styles.navItem}`}
          >
            <span className={styles.price}>{cart?.length}</span>
            <FontAwesomeIcon icon={faCartShopping} />
          </Link>
          <FontAwesomeIcon icon={faUser} />
        </div>
      </nav>
      <Navbar className={`${styles.NavBar} d-none d-lg-block`} sticky="top">
        <Container>
          <NavLink className={styles.logo} to="/">
            <img style={{ height: "40px" }} src={Logo} alt="MR. CAFE" />
          </NavLink>
          <Nav className="ms-auto">
            <NavLink className={styles.navItem} to="/">
              Home
            </NavLink>
            <NavLink className={styles.navItem} to="/about">
              About Us
            </NavLink>
            <NavLink className={`${styles.navItem}`} to="/drinks">
              Coffee & Drinks
            </NavLink>
            <NavLink className={`${styles.navItem}`} to="/foods">
              Food Menu
            </NavLink>
            <NavLink className={`${styles.navItem}`} to="/reservation">
              Reservation
            </NavLink>
            <NavLink className={`${styles.navItem}`} to="/contact">
              Contact Us
            </NavLink>
          </Nav>

          <div className={styles.search}>
            {isSearch && (
              <div className={styles.searchBar}>
                <input type="text" placeholder="Search here..." />
              </div>
            )}
            <span onClick={() => setIsSearch(!isSearch)}>
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </span>
          </div>

          <Link
            to="/cart"
            className={`d-flex align-items-center gap-2 ${styles.navItem}`}
          >
            <FontAwesomeIcon icon={faCartShopping} />
            <span className={styles.price}>{cart?.length}</span>
          </Link>
          <div className={styles.cartItem}>
            {isLogin && <FontAwesomeIcon icon={faUser} />}
            {isLogin === true ? (
              <span
                className={styles.navItem}
                onClick={() => {
                  setIsLogin(false);
                }}
              >
                Jocab
              </span>
            ) : (
              <Link to="/authenticate/login" className={styles.navItem}>
                Sign In
              </Link>
            )}
          </div>
        </Container>
      </Navbar>
    </>
  );
}

export default NavBar;
